<div class="property-status" [ngClass]="status">
  {{
    (status === 'OPEN' || status === 'UNVERIFIED' ? 'active' : status)
      | stringTransform: 'capitalizeFirstLetter'
  }}
</div>
